import { Node } from 'tiptap';

export default class Inputs extends Node {
  // eslint-disable-next-line class-methods-use-this
  get name() {
    return 'inputs';
  }

  // eslint-disable-next-line class-methods-use-this
  get view() {
    return {
      props: ['node', 'updateAttrs', 'view', 'options', 'editable', 'getPos'],
      methods: {
        onChange(e) {
          this.updateAttrs({
            value: e.target.value,
          });
        },
      },
      template: `
        <input type="text"
               class="editor-input"
               :placeholder="node.attrs.placeholder"
               :value="node.attrs.value"
               :id="node.attrs.id"
               maxlength="20"
               :contenteditable="true"
               @change="onChange($event)"
        />
      `,
    };
  }

  // eslint-disable-next-line class-methods-use-this
  get schema() {
    return {
      inline: true,
      attrs: {
        placeholder: {
          default: 'Text will go here',
        },
        value: {
          default: '',
        },
        id: {
          default: null,
        },
      },
      group: 'inline',
      content: 'text*',
      size: 'text*',
      toDOM: node => {
        const { placeholder, value, id } = node.attrs;
        return [
          'input',
          {
            placeholder,
            type: 'text',
            class: 'editor-input',
            maxlength: 20,
            value,
            id,
          },
          0,
        ];
      },
      parseDOM: [
        {
          tag: 'input',
          getAttrs: dom => ({
            type: 'text',
            placeholder: 'Text will go here',
            value: dom.getAttribute('value'),
            id: dom.getAttribute('id'),
            maxlength: 20,
          }),
        },
      ],
    };
  }

  // eslint-disable-next-line class-methods-use-this
  commands({ type }) {
    return attrs => (state, dispatch) => {
      const { selection } = state;
      const position = selection.$cursor ? selection.$cursor.pos : selection.$to.pos;
      const node = type.create(attrs);
      const transaction = state.tr.insert(position, node);
      dispatch(transaction);
    };
  }
}



// WEBPACK FOOTER //
// ./src/includes/inputs.js